import { render, staticRenderFns } from "./ui-buttontests.vue?vue&type=template&id=c566d8da&scoped=true"
import script from "./ui-buttontests.vue?vue&type=script&lang=ts"
export * from "./ui-buttontests.vue?vue&type=script&lang=ts"
import style0 from "./ui-buttontests.vue?vue&type=style&index=0&id=c566d8da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c566d8da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c566d8da')) {
      api.createRecord('c566d8da', component.options)
    } else {
      api.reload('c566d8da', component.options)
    }
    module.hot.accept("./ui-buttontests.vue?vue&type=template&id=c566d8da&scoped=true", function () {
      api.rerender('c566d8da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/button/ui-buttontests.vue"
export default component.exports